import React from "react";

const CourseModal = ({
  isModalOpen,
  editDepartment,
  editCourseLevel,
  handleInputChange,
  handleSave,
  closeModal,
}) => {
  if (!isModalOpen) return null;

  return (
    <div className="fixed inset-0 flex justify-center items-center bg-black bg-opacity-50">
      <div className="bg-white p-6 rounded-lg w-3/4 md:w-1/2">
        <h3 className="text-2xl font-semibold mb-4">Edit Course</h3>

        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-4">
          <div className="col-span-2">
            <label
              htmlFor="courseName"
              className="block text-sm font-medium text-gray-700"
            >
              Course Name
            </label>
            <input
              type="text"
              id="courseName"
              name="name"
              value={editDepartment.name || ""}
              onChange={handleInputChange}
              className="mt-1 p-2 w-full border rounded-md"
            />
          </div>
          <div className="col-span-2">
            <label
              htmlFor="departmentId"
              className="block text-sm font-medium text-gray-700"
            >
              Department Name
            </label>
            <input
              type="text"
              id="departmentId"
              name="departmentId"
              value={editDepartment.departmentId || ""}
              onChange={handleInputChange}
              className="mt-1 p-2 w-full border rounded-md"
            />
          </div>
          <div className="col-span-2">
            <label
              htmlFor="credits"
              className="block text-sm font-medium text-gray-700"
            >
              Credits
            </label>

            <select
              name="credits"
              value={editDepartment.credits || ""}
              onChange={handleInputChange}
              className="mt-1 p-3 w-full bg-gray-100 rounded-md focus:ring-[#ffa404]"
              required
            >
              <option value="">Select Credits</option>
              <option value="1">1 </option>
              <option value="2">2 </option>
              <option value="3">3 </option>
            </select>
          </div>
          <div>
            <label>
              Course Type
            </label>
                         
          </div>

          <div className="col-span-2">
            <label
              htmlFor="maxStudents"
              className="block text-sm font-medium text-gray-700"
            >
              Max Students
            </label>
            <input
              type="number"
              id="maxStudents"
              name="maxStudents"
              value={editDepartment.maxStudents || ""}
              onChange={handleInputChange}
              className="mt-1 p-2 w-full border rounded-md"
            />
          </div>
          {/* Add other fields as required */}
        </div>

        <div className="flex justify-end mt-4">
          <button
            onClick={handleSave}
            className="bg-blue-500 text-white p-2 rounded-md"
          >
            Save Changes
          </button>
          <button
            onClick={closeModal}
            className="bg-gray-300 text-black p-2 rounded-md ml-2"
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};

export default CourseModal;
